export class UsrPwd {
    fTxtMail: string;
    fTxtPwd: string;
}

export class UserAut {
    acepto: boolean;
    autorizado: string;
    cedula: string;
    nombre: string;
    contacto: string;
    dirUsr: string;
    email: string;
    fechaHora: string;
    telfContacto: string;
    uid: string;
}

export class UserEmp {
    email: string;
    empresas: object;
    nombre: string;
    uid: string;
}

export class SuperUser {
    super: boolean;
}

export class User {
    uid: string;
    nombre: string;
    cedula: string;
    contacto: string;
    telfContacto: string;
    dirUsr: string;
    email: string;
    acepto: boolean;
    fechaHora: string;
    foto: string;
    tipoUsuario: string;    //Por ahora puede ser Admin o Usuario
    extraSize: string;      //0px, 1px, ... 4px
}
